import {event} from '../modules/event';
import {ajax} from '../modules/ajax';

export default class {
    /*
    *
    * */
	constructor(wrapper) {
		this.wrapper = wrapper;
		this.data = JSON.parse(this.wrapper.getAttribute('data-param'));
		this.rating = this.wrapper.getAttribute('data-js') == 'rating-box' ? this.wrapper : this.wrapper.querySelector('[data-js="rating-box"]');
        this.isAllowVote = this.rating.className.indexOf('js-allowVote') === -1 ? false : true;
		this.isSending = false;
        this.onchange = function(){};
		this._defineAjaxPath();
		this._findItems();
        this._addEvents();
		this._addToGlobal();
	}

	_defineAjaxPath(){
        var part = APP.vars.isDev ? '/_src/layouts' : '';
		this.ajaxPath = part + '/' + this.data.type + '/' + this.data.uid + '/vote/';
	}

	_findItems(){
        var self = this;
		this.star=[];//массив звезд
		this.numRating = this.rating.querySelector('[data-js="numRating"]');
		this.stars = this.rating.querySelector('[data-js="stars"]');
		this.starAll =  this.rating.querySelectorAll('[data-star]');
        this.vote = this.rating.querySelector('[data-js="vote"]');
		this.votes = this.rating.querySelector('[data-js="votes"]');
        this.markEl = this.rating.querySelector('[data-js="mark"]');
        this.userMark = function(){
            if(!self.markEl) return false;
            var result = self.markEl.firstChild.nodeValue.match( /\d+/ );
            if(!result) return false;
            return parseInt(result[0]);
        }();
	}

    _addEvents(){
        var self = this;

        event.add(this.rating, 'click', function(){
            if(!self.isAllowVote){
                try{console.log('Ваш рейтинг уже учтен')} catch(e){}
                /*uPopup({
                    content:'Ваш рейтинг уже учтен'
                });*/
            }
        });

        for(var i=0,j=this.starAll.length;i<j;i++){
            event.add(this.starAll[i], 'click', function(e){
                e.preventDefault();
                e.stopPropagation();

                if (APP.vars.isMobile) {
                    if (!APP.auth.tryAuth()) return false;
                } else if (!regAuthObj.isAuth) {
                    regAuthObj.authForm.showPopup();
                    return false;
                }

                if(self.isSending) return false;
                self.isSending = true;

                ajax({
                    data:{"vote":this.getAttribute('data-star') },
                    url:self.ajaxPath,
                    callback: function(msg){
                        self._checkAnswer.call(self, msg);
                    }
                });
            });

            /*event.add(this.starAll[i], 'mouseover', function(e){
                if(self.isSending) return false;
                if(self.markEl) self.markEl.firstChild.nodeValue = 'Ваша оценка ' + this.getAttribute('data-star');
            });*/
        }

        if(this.markEl && this.isAllowVote && (!('ontouchstart' in window))){
            for(var i=0,j=this.starAll.length;i<j;i++){
                event.add(this.starAll[i], 'mouseover', function(e){
                    if(self.isSending || !self.isAllowVote) return false;
                    self.markEl.firstChild.nodeValue = 'Ваша оценка ' + this.getAttribute('data-star');
                });
            }

            event.add(this.vote, 'mouseout', function(e){
                if(self.isSending || !self.isAllowVote) return false;
                var text = self.userMark ? 'Ваша оценка ' + self.userMark : 'Оцените';
                self.markEl.firstChild.nodeValue = text;
            });
        }
    }

    _checkAnswer(msg){
		var msg = JSON.parse(msg);

		if (msg.auth === false){
            if (APP.vars.isMobile) {
                alert('Вам нужно авторизоваться повторно.');
            } else {
                uPopup({
                    content: 'Вам нужно авторизоваться повторно.',
                    oncloseBefore: function () {
                        location.replace(location.protocol + '//' + location.host + location.pathname);
                    }
                });
            }
		}
		else if(!msg.status){
            if (APP.vars.isMobile) {
                alert(msg.message);
            } else {
                uPopup({
                    content: msg.message
                });
            }
		}
		else {
            this._addVote(msg);
            //если задали функию успешного выполнения скрипта, запускаем
            if(this.successExec) this.successExec();
        }

		this.isSending = false;
	}

	_decline (number, titles) {
		var cases = [2, 0, 1, 1, 1, 2];
		return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
	}

    _addVote(msg){
        var key = 'uid-' + this.data.uid,
            type = this.data.type,
            all = window.GLOBALS[type+'RatingAll'][key];

        for(var i= 0,j=all.length; i<j; i++){
            var width = all[i].data.stars === 'mark' ? msg.data.mark : msg.data.rating;
           all[i].stars.style.width = width*10+'%';

            if(all[i].numRating && (msg.data.votes>9)) {
                var treated = (msg.data.rating+'');
                //treated = treated.replace(/\./, ',');
                //treated = treated.indexOf(',') !== -1 ? treated : treated + ',0';
                treated = treated.indexOf('.') !== -1 ? treated : treated + '.0';
                all[i].numRating.innerHTML = treated;
            }
            if(all[i].votes)  {
                /* стираем что внутри - ибо может быть дополнительный спан seo - в фильмах */
                all[i].votes.innerHTML = msg.data.votes + ' ' + all[i]._decline(msg.data.votes, ['голос', 'голоса', 'голосов']);
            }
            if(all[i].markEl){
                all[i].userMark = msg.data.mark;
                all[i].markEl.firstChild.nodeValue = 'Ваша оценка ' + msg.data.mark;
            }

            //all[i].rating.className = all[i].rating.className.replace('js-allowVote', '');
            //all[i].isAllowVote = false;
        }

        this._sendStat();

        this.onchange(msg.data.rating);
    }

    _sendStat(){
        if ( this.data.type ){
            try {
                gtag('event', 'click', {
                    'event_category': 'engagement',
                    'event_label': 'rate_' + this.data.type
                });
                console.log('gtag success!');
            } catch (error){
                console.log('gtag error:', error);
            }
        } else {
            console.log('gtag unknow type');
        }
    }

    _addToGlobal (){
        var key = 'uid-' + this.data.uid;
        var type = this.data.type;

        if(!window.GLOBALS) window.GLOBALS = {};
        if(!window.GLOBALS[type+'RatingAll']) window.GLOBALS[type+'RatingAll'] = {};
        if(!window.GLOBALS[type+'RatingAll'][key]) window.GLOBALS[type+'RatingAll'][key] = [];

        window.GLOBALS[type+'RatingAll'][key].push(this);
    }

    del(){
        var key = 'uid-' + this.data.uid;
        var type = this.data.type;
        var all = window.GLOBALS[type+'RatingAll'][key];

        for(var i= 0,j=all.length; i<j; i++){
            if(all[i] === this) {
                all.splice(i, 1);
                if(!all.length) delete window.GLOBALS[type+'RatingAll'][key];
                return false;
            }
        }
    }
};


































